import { Link } from "react-router-dom";
import { useEffect } from 'react';
import { useAuth } from "../context/AuthContext";
import AuthenticatedLayout from "../Layouts/AuthenticatedLayout";
import GuestLayout from "../Layouts/GuestLayout";

export default function NotFound() {
  const { user } = useAuth();

  useEffect(() => {
    document.title = '404 - Coffee Roast City';
}, []);

  // Define the NotFound content
  const NotFoundContent = (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r">
      <div className="text-center">
        <h1 className="text-8xl font-extrabold text-blue-500 mb-4 animate-bounce">
          404
        </h1>
        <p className="text-xl text-gray-700 mb-6">
          Oops! Η σελίδα που αναζητάτε δεν υπάρχει.
        </p>
        <Link
          to="/"
          className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 rounded-full shadow hover:bg-blue-700 transition duration-300"
        >
          Επιστροφή στην Αρχική Σελίδα
        </Link>
      </div>
    </div>
  );

  // Render appropriate layout based on authentication state
  return user ? (
    <AuthenticatedLayout>{NotFoundContent}</AuthenticatedLayout>
  ) : (
    <GuestLayout>{NotFoundContent}</GuestLayout>
  );
}
